import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMatomo } from '@datapunt/matomo-tracker-react';

const useMatomoTracker = () => {
  const { trackPageView, trackEvent } = useMatomo();
  const location = useLocation();

  useEffect(() => {
    // 跟踪页面视图
    trackPageView({
      documentTitle: document.title,
      href: window.location.href,
    });
  }, [location.pathname, trackPageView]);

  return { trackEvent };
};

export default useMatomoTracker;